import type { QuestionDefinition } from "@reno-estimator/core";
import { builtInsQuestion, flooringQuestion, lightingQuestion, paintingQuestion, trimQuestion } from "./interior-room-shared.js";

/**
 * Home Office (Phase 13A) - see rules/home-office.ts for the matching
 * calculator. No windows/doors question; electrical/data wiring is its
 * own tiered question here instead of relying on the common
 * electrical_changes flag alone, since that's the scope that most
 * differentiates a home office renovation from any other room.
 */
export const homeOfficeQuestions: QuestionDefinition[] = [
  flooringQuestion("home_office", 200, "home office"),
  paintingQuestion("home_office", 210),
  trimQuestion("home_office", 220),
  lightingQuestion("home_office", 230),
  builtInsQuestion("home_office", 240, "What about a built-in desk or shelving?", "Custom built-in desk/shelving"),
  {
    id: "home_office_electrical_data",
    projectTypes: ["home_office"],
    inputType: "single_select",
    prompt: "Any additional electrical or data/network wiring?",
    helpText: "Extra circuits for equipment, or dedicated network/AV wiring.",
    required: false,
    options: [
      { id: "none", label: "None" },
      { id: "extra_circuits", label: "Additional circuits" },
      { id: "network_av", label: "Dedicated network/AV wiring" }
    ],
    order: 260
  }
];
